import { render, staticRenderFns } from "./InviraUserShow.vue?vue&type=template&id=3d2eab12"
import script from "./InviraUserShow.vue?vue&type=script&lang=js"
export * from "./InviraUserShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports